const classe = new Map();

const label = new Map();

classe.set('EM_PROCESSAMENTO', 'em-processamento');
classe.set('PROCESSADO', 'processado');
classe.set('NA_FILA', 'na-fila');
classe.set('CANCELADO', 'cancelado');
classe.set('FALHA_PROCESSAMENTO', 'falha-processamento');

label.set('EM_PROCESSAMENTO', 'laudos.emProcessamento');
label.set('PROCESSADO', 'laudos.processado');
label.set('NA_FILA', 'laudos.naFila');
label.set('CANCELADO', 'laudos.cancelado');
label.set('FALHA_PROCESSAMENTO', 'laudos.falhaNoProcessamento');

export { classe, label };
